import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fennira-brand.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import { registerServiceWorker } from './registerServiceWorker';
import { installAuthInterceptor } from './authClient';

// Before anything renders, so the very first request a component fires is
// already covered. The access token is short-lived now; this is what trades the
// refresh token for a new one instead of dropping the user at the login screen.
installAuthInterceptor();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <App />
    
    </BrowserRouter>
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Makes the app installable to a phone's home screen and gives it an offline
// shell. Production-only — see registerServiceWorker.js.
registerServiceWorker();
